export default "/images/product-4.png?55dbe9ebf86684ceb616060bb37e8cdc";